import { Dispatch } from 'react';
import { SuSyApi } from '../../api/susyApi';
import { AdminPermission } from '../../definitions/enums/permissions';
import {
    Department,
    Faculty,
    Intake,
    PostDispatch,
    Program,
    SupervisorGroup,
    User,
} from '../types';

import { UserRole } from 'susy-common/models';

import { UserActionType } from '../actionTypes/user';

export interface MultipleUserRoleAndOrganizations {
    intakes: Array<Intake>;
    programs: Array<Program>;
    faculties: Array<Faculty>;
    departments: Array<Department>;
    supervisorGroups: Array<SupervisorGroup>;
    users: Array<User>;
    userRole: UserRole;
}

export const getAllUsers = () => async (dispatch: Dispatch<PostDispatch>) => {
    const response = await SuSyApi.get(`/user/`);
    dispatch({ type: UserActionType.GET_ALL_USERS, payload: response.data });
};

export const getUsersWithProfilePicture =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(`/user/profilePicture/all`);
        dispatch({
            type: UserActionType.GET_USERS_WITH_PROFILE_PICTURES,
            payload: response.data,
        });
    };

export const createUser =
    (user: User) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.post(`/user/`, user);
        dispatch({ type: UserActionType.CREATE_USER, payload: response.data });
    };
export const updateUser =
    (user: User) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.put(`/user/${user._id}`, user);
        dispatch({ type: UserActionType.UPDATE_USER, payload: response.data });
    };

export const updateUserAndPermissions =
    (user: User) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.put(
            `/user/withPermissions/${user._id}`,
            user
        );
        dispatch({ type: UserActionType.UPDATE_USER, payload: response.data });
    };

export const updateMultipleUsers =
    (multipleUserRoleAndOrganizations: MultipleUserRoleAndOrganizations) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.put(
            'user/users/userRoleAndOrganizations',
            multipleUserRoleAndOrganizations
        );
        dispatch({
            type: UserActionType.UPDATE_MULTIPLE_USER,
            payload: response.data,
        });
    };

export const updateMultipleUsersWithPermissions =
    (
        multipleUserRoleAndOrganizations: MultipleUserRoleAndOrganizations,
        permissions: Array<AdminPermission>
    ) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.put(
            'user/users/updateMultipleUsersWithPermissions',
            {
                multipleUserRoleAndOrganizations,
                permissions,
            }
        );
        dispatch({
            type: UserActionType.UPDATE_MULTIPLE_USER,
            payload: response.data,
        });
    };

export const getUsersWithActiveProjects =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get('/user/projects/active');
        dispatch({
            type: UserActionType.GET_USERS_WITH_ACTIVE_PROJECTS,
            payload: response.data,
        });
    };

export const getUserById =
    (userId: string) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(`/user/${userId}`);
        dispatch({
            type: UserActionType.GET_USER_BY_ID,
            payload: response.data,
        });
    };

export const getAllUsersRoleUser =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(`/user/getUsers/user`);
        dispatch({
            type: UserActionType.GET_USERS_ROLE_USER,
            payload: response.data,
        });
    };

